"use client";

import { useTranslations } from "next-intl";
import { Dispatch, SetStateAction } from "react";
import { Building, House } from "lucide-react";
import TitleH5 from "../fonts/TitleH5";

type PropertyType = "multiFamilyHouse" | "singleFamilyHouse";

interface ChoosePropertyProps {
  propertyType: PropertyType;
  setPropertyType: Dispatch<SetStateAction<PropertyType>>;
}

const style = `text-primary lg:hover:border-primary  flex cursor-pointer flex-col items-center justify-center gap-4 border-2 p-8 font-medium shadow-md transition-colors duration-400`;

const ChooseProperty = ({ ...props }: ChoosePropertyProps) => {
  const tC = useTranslations("common");
  const tH = useTranslations("measurementService.priceCalculation");

  return (
    <div className="flex flex-col items-center justify-center gap-5">
      <TitleH5 title={tH("subTitle")} />

      <div className="flex flex-col items-center gap-5 sm:flex-row">
        <button
          className={`${style} ${props.propertyType === "singleFamilyHouse" ? "border-primary" : "border-transparent"}`}
          onClick={() => props.setPropertyType("singleFamilyHouse")}
        >
          <House size={50} />
          <span>
            {tC("singleFamilyHouse")} {tC("or")}
            <br />
            {tC("flat")}
          </span>
        </button>

        <button
          className={`${style} ${props.propertyType === "multiFamilyHouse" ? "border-primary" : "border-transparent"}`}
          onClick={() => props.setPropertyType("multiFamilyHouse")}
        >
          <Building size={50} />
          <span>
            {tC("multiFamilyHouse")} {tC("or")}
            <br />
            {tC("business")}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ChooseProperty;
